import { render, staticRenderFns } from "./ListTestProviders.vue?vue&type=template&id=1a05c874&"
import script from "./ListTestProviders.vue?vue&type=script&lang=js&"
export * from "./ListTestProviders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports